import styled, { keyframes } from "styled-components";

import openMenuIcon from "../../images/icons/open-menu.svg";
import goBackIcon from "../../images/icons/go-back-icon.svg";

export const openMenuSolutions = keyframes`
  from {
    opacity: 0;
  }
   to {
    opacity: 1;
  }
`;

export const Nav = styled.div`
  margin-top: 30px;
`;

export const SkipeToContent = styled.a`
  display: inline-block;
  height: 48px;
  padding: 12px 32px 14px;
  border-radius: 4px;
  text-decoration: none;
  font-size: 12.6px;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0.8px;
  text-align: center;
  text-transform: uppercase;
  cursor: pointer;
  white-space: nowrap;
  border: none;

  border: 2px solid #222;
  color: #222;

  position: absolute;
  top: -100px;
  left: 24px;
  opacity: 0;

  transition: opacity 0.25s;

  :focus {
    top: 24px;
    opacity: 1;
    outline: none;
  }

  @media (max-width: 1049px) {
    display: none;
  }
`;

export const NavWrapper = styled.header`
  position: -webkit-sticky;
  position: -moz-sticky;
  position: -ms-sticky;
  position: -o-sticky;
  position: sticky;
  top: 0;
  width: 100%;
  display: flex;
  flex-direction: column;

  padding-top: 32px;
  transition: all 0.2s;

  z-index: 4;
  background-color: #ffffff;
  /* box-shadow: 0px 9px 15px rgba(0, 0, 0, 0.05); */

  @media (max-width: 1049px) {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
`;

export const NewNavWrapper = styled(NavWrapper)`
  top: 0;
  width: 100%;
  display: flex;
  flex-direction: column;

  padding-top: 32px;
  transition: all 0.2s;

  z-index: 4;
  background-color: #222;

  @media (max-width: 1049px) {
    top: 0;
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
`;

export const CleanNavWrapper = styled(NavWrapper)`
  top: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;

  padding-top: 32px;
  transition: all 0.2s;

  z-index: 4;
  background-color: #ffffff;

  @media (max-width: 1049px) {
    top: 40px;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
`;

export const OneNavBar = styled.header`
  position: absolute;

  top: 24px;
  width: 100%;
  display: flex;
  flex-direction: column;

  padding-top: 32px;
  transition: all 0.2s;

  z-index: 4;
  background-color: #ffffff;

  @media (max-width: 1049px) {
    top: 40px;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  box-shadow: none !important;
`;

export const MktNavWrapper = styled.header`
  width: 100%;
  height: 80px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 32px;

  z-index: 3;
  background-color: #fff;

  @media (max-width: 1049px) {
    margin-top: 0;
  }
`;

export const Container = styled.nav`
  width: 100%;
  max-width: 1344px;
  margin: 0 auto;
  padding: 0 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1049px) {
    padding: 21px 24px;
  }
`;

export const NewContainer = styled(Container)`
  max-width: 1248px;
  padding: 0 48px;

  @media (max-width: 1049px) {
    padding: 0 24px;
  }
`;

export const ContainerOne = styled(Container)`
  max-width: 100%;
  padding: 0 24px;
`;

export const MenuWrapper = styled.ul`
  width: 100%;
  display: flex;
  align-items: center;
  height: 80px;
  background-color: #fff;

  > a {
    margin-left: 48px;
  }

  @media (max-width: 1049px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    min-width: 100%;
    position: fixed;
    top: 52px;
    left: 0;
    right: 0;
    bottom: 0;

    padding: 30px 24px 32px;

    display: ${({ open }) => (open ? "flex" : "none")};
    animation: ${openMenuSolutions} 0.15s linear;

    overflow-y: auto;
    z-index: 1;

    > a {
      margin-left: 0;
    }
  }
`;

export const MenuWrapperThankyouPage = styled(MenuWrapper)`
  min-height: 115px;

  @media (max-width: 1049px) {
    top: ${({ open }) => (open ? "0" : "60px")};
  }
`;

export const MenuWrapperNoScapePage = styled(MenuWrapper)`
  width: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: 80px;

  button {
    margin-left: 64px;
  }

  @media (max-width: 1049px) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    min-width: 100%;

    position: fixed;
    top: 46px;
    left: 0;
    right: 0;
    bottom: 0;

    padding: 30px 24px 32px;

    button {
      margin-left: 0;
    }

    display: ${({ open }) => (open ? "flex" : "none")};
    animation: ${openMenuSolutions} 0.15s linear;
  }
`;
export const NewMenuWrapperNoScapePage = styled(MenuWrapperNoScapePage)`
  color: var(--white);
  background-color: #222;
`;

export const MenuWrapperNoScapeFormPage = styled.div`
  width: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 80px;

  @media (max-width: 1049px) {
    height: 12px;
  }
`;

export const SolutionsWrapper = styled.li`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;

  opacity: ${({ visible }) => (visible ? 1 : 0)};
  pointer-events: ${({ visible }) => (visible ? "unset" : "none")};
  transition: opacity 0.2s 0.125s ease-in;

  @media (max-width: 1049px) {
    position: relative;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    max-width: 100%;
    top: 24px;
    display: block;
    overflow: hidden;
  }
`;

export const ToggleSolutions = styled.button`
  display: inline-block;
  font-size: 14px;
  line-height: 24.5px;
  color: var(--dark-gray);
  text-decoration: none;
  border: none;
  outline: none;
  padding: 0;
  cursor: pointer;
  height: 80px;
  transition: all 0.2s 0.125s ease-in;
  position: relative;

  ::after {
    content: url(${openMenuIcon});
    height: 16px;
    display: inline-block;
    position: absolute;
    top: calc(50% - 8px);
    right: -4px;
    transition: all 0.2s 0.125s ease-in;
    transform: ${({ openSolutions }) =>
      openSolutions ? "rotate(180deg)" : "rotate(0)"};
  }

  padding-right: 20px;

  @media (max-width: 1049px) {
    height: 24px;
    color: var(--black);
    font-size: 16px;
    ::after {
      top: 4px;
    }
  }
`;

export const ToggleSolutionsWrapper = styled.li`
  @media (max-width: 1049px) {
    margin-bottom: 32px;
    min-width: 100%;
    position: relative;

    ul {
      /* margin-top: -16px; */
    }
  }
`;

export const NavLink = styled.a`
  display: inline-block;
  font-size: 14px;
  line-height: 24.5px;
  color: var(--dark-gray);
  text-decoration: none;
  transition: all 0.2s;

  :hover {
    color: var(--orange);
  }

  @media (max-width: 1049px) {
    color: var(--black);
    font-size: 16px;
    margin: 32px 0;
  }
`;

export const NewNavLink = styled(NavLink)`
  color: #fff;

  @media (max-width: 1049px) {
    color: #fff;
  }
`;

export const GoBackNavLink = styled.button`
  width: 30px;
  height: 30px;
  padding: 5px;
  border: 0;
  background-color: #fff;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 0;

  ::after {
    transition: all 0.2s;
    content: url(${goBackIcon});
  }

  :hover {
    ::after {
      transform: scale(1.25);
    }
  }
`;

export const ContactWrapper = styled.div`
  display: flex;
  align-items: center;

  margin-left: auto;

  a {
    margin-left: 48px;
  }

  @media (max-width: 1049px) {
    width: 100%;
    flex-direction: column;
    margin-top: auto;
    padding-top: 64px;

    a {
      margin: 0;
    }

    a + a {
      margin-top: 24px;
      width: 100%;
    }
  }
`;

export const BoxCtaDesktop = styled.div`
  margin-left: 48px;

  @media (max-width: 1049px) {
    display: none;
  }
`;
